<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2020-04-28 10:34:47
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-03-05 11:00:59
 -->
<template>
  <div :class="['right_slip', visible ? 'show' : '']">
    <!-- <div class="right_slip_left"  @click="close"></div> -->
    <div ref="rightMain" :class="['right_slip_main', showBox ? 'blk' : 'none']">
      <div class="right_slip_box">
        <template v-for="(item, index) in list">
          <template v-if="item.children && item.children.length > 0">
            <!-- <template v-if="item.path == '/innovative'"> -->
            <template>
              <template v-for="$item in item.children">
                <div :key="$item.meta.checked">
                  <div :class="['right_slip_list border-b', $item.path == $route.path ? 'active' : '', language == 'en' ? 'fz-26' : '']" :key="$item.meta.checked" v-html="$t(`${$item.title}`)" @click="rightListClick($item.path)"></div>
                  <template v-for="$list in $item.children">
                    <div :key="$list.title" class="right_slip_list right_slip_collapse" :class="language == 'en' ? 'fz-22' : ''">
                      <van-collapse v-model="activeNames" accordion>
                        <van-collapse-item :title="$t(`${$list.title}`).join('')" :name="$list.name">
                          <div :class="['collapse-item', _$item.path == $route.path ? 'active' : '', language == 'en' ? 'fz-22' : '']" v-for="_$item in $list.list" :key="_$item.path" @click="rightListClick(_$item.path)">
                            <span class="ilblk" v-html="$t(`${_$item.title}`)"></span>
                            <img v-if="_$item.hot" class="collapse-item-img" :src="require('@/assets/images/icons/hot.png')" alt="" srcset="">
                          </div>
                        </van-collapse-item>
                      </van-collapse>
                    </div>
                  </template>
                </div>
              </template>
            </template>
            <!-- <template v-else>
              <div :key="item.meta.checked">
                <van-collapse v-model="activeNames" accordion class="oneLevel-collapse">
                  <van-collapse-item :title="$t(`${item.meta.title}`)" :name="item.name" class="">
                    <div :class="['collapse-item', _$item.path == $route.path ? 'active' : '']" v-for="_$item in item.children" :key="_$item.path" @click="rightListClick(_$item.path)">
                      <span class="ilblk" v-html="$t(`${_$item.meta.title}`)"></span>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </template> -->
          </template>
          <div :key="index" v-else :class="['right_slip_list border-b', resolvePath(item.path) ? ['active']:'']" @click="rightListClick(item.path)" v-html="$t(`${item.meta.title}`)"></div>
        </template>
        <div :class="['right_slip_list', 'flex justify_content_between align_items_center', isMac ? 'p-b-50' : '' ]" @click="languageChange">
          <div>{{language == 'zh' ? '语言' : 'Language'}}</div>
          <div class="p-r-34 fz-34">{{language == 'en' ? 'CN' : 'EN'}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import path from 'path'
export default {
  name: 'RightSlip',
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showBox: true,
      activeNames: ''
    }
  },
  computed: {
    ...mapGetters([
      'language'
    ]),
    isMac () {
      return (/macintosh|mac os x/i.test(navigator.userAgent))
    }
  },
  methods: {
    show () {
      // this.activeNames = this.language === 'en' ? '/en/innovative/accuffrCt' : this.$route.path.indexOf('/innovative/') !== -1 ? this.$route.meta.type.name : ''
      this.activeNames = this.$route.path.indexOf('/innovative/') !== -1 || this.$route.path.indexOf('/en/innovative/') !== -1 ? this.$route.meta.type.name : ''
      document.documentElement.style.overflowY = 'hidden'
    },
    close () {
      this.$refs.rightMain.scrollTop = 0
      // this.activeNames = this.language === 'en' ? '/en/innovative/accuffrCt' : ''
      this.activeNames = ''
      document.documentElement.style.overflowY = 'auto'
    },
    rightListClick (_path) {
      this.close()
      this.$emit('rightSlipList', _path)
    },
    async languageChange (index) {
      this.showBox = false
      this.close()
      // const language = this.language === 'zh' ? 'en' : 'zh'
      // this.$store.dispatch('app/setLanaguage', language).then(() => {
      //   location.reload()
      // })
      const language = this.language === 'zh' ? 'en' : 'zh'
      const _url = language === 'en' ? process.env.VUE_APP_HOST_EN : process.env.VUE_APP_HOST_ZH
      // this.$store.dispatch('app/setLanaguage', language).then(() => {
      //   // this.$i18n.locale = language
      //   window.location.replace(_url)
      // })
      window.location.replace(_url)
    },
    resolvePath (_path) {
      let flag = false
      if (_path === path.resolve(this.$route.path)) {
        flag = true
      }
      return flag
    }
  }
}
</script>
<style lang="less" scoped>
.right_slip{
    .right_slip_left{
        width: 100vw;
        height: 10vh;
        background: rgba(0,0,0,0.91);
    }
    .right_slip_main{
      // width: 5.85rem;
      width: 100vw;
      height: calc(100vh + 2px);
      padding-bottom: 90px;
      position: absolute;
      // left: -200%;
      left: -120vw;
      top: 1px;
      overflow: hidden;
      background: rgba(0, 0, 0, 0.91);
      white-space: nowrap;
      padding-top: 100px;
      transition: all 0.5s;
      -ms-transition: all 0.5s ease;
      -moz-transition: all 0.5s ease;
      -webkit-transition: all 0.5s ease;
      -o-transition: all 0.5s ease;
      opacity: 0.4;
    }
    .right_slip_box{
      padding-top: 0.8px;
      overflow-y: auto;
      height: 100%;
      padding-bottom: 30px;
    }
    .right_slip_list{
      font-size: 30px;
      line-height: 42px;
      color: #ffffff;
      padding: 28px 0;
      margin: 0 30px;
      position: relative;
      white-space: normal;
      &.active {
        color: #00A0E9;
      }
      &.border-b {
        border-bottom: 1px solid rgba(255, 255, 255, 0.22);
      }
      &.right_slip_collapse {
        padding-bottom: 0;
      }
      &:last-child {
        border-bottom-width: 0;
      }
    }
    &.show{
        right: 0;
        top: 0;
        .right_slip_left {
          right: 0;
          top: 0;
        }
        .right_slip_main{
          left: 0;
          opacity: 1;
        }
    }
}
</style>

<style lang="less">
  .right_slip {
    .right_slip_list {
      .van-cell {
        background: none;
        font-size: 28px;
        line-height: 42px;
        color: #ffffff;
        padding: 0 0 28px 0;
        margin-left: 30px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.22);
        &::after{
          border: none;
        }
      }
    }
  }
  .en {
    .right_slip {
      .right_slip_list {
        .van-cell {
          font-size: 24px;
        }
      }
    }
  }
</style>
<style lang="less">
  .right_slip {
    .van-cell {
      background: none;
      font-size: 28px;
      line-height: 42px;
      color: #ffffff;
      // padding: 28px 35px;
      // border-bottom: 1px solid rgba(255, 255, 255, 0.22);
      &::after{
        border: none;
      }
    }
    .van-cell__title {
      -webkit-box-flex: 1;
      -ms-flex: initial;
      -webkit-flex: initial;
      flex: initial;
    }
    .van-cell__right-icon {
      font-size: 26px;
      color: #ffffff;
      margin-left: 8px;
    }
    .van-collapse-item__title {
      width: auto;
    }
    .van-collapse-item__title--expanded {
      padding-bottom: 16px;
    }
    .van-collapse-item__wrapper {
      max-height: 400px;
      transition: all .5s ease-in;
      -ms-transition: all .5s ease-in;
      -moz-transition: all .5s ease-in;
      -webkit-transition: all .5s ease-in;
      -o-transition: all .5s ease-in;
      // transition: max-height 0.5s ease-in;
      // -webkit-transform: max-height 0.5s ease-in;
      &.hide {
        // 收缩
        overflow: hidden;
        max-height: 0;
        transition: all .5s ease-out;
        -ms-transition: all .5s ease-out;
        -moz-transition: all .5s ease-out;
        -webkit-transition: all .5s ease-out;
        -o-transition: all .5s ease-out;
      }
    }
    .van-collapse-item__content {
      background: none;
      font-size: 24px;
      line-height: 42px;
      color: #ffffff;
      padding: 0 0 0 30PX;
      .active {
        color: #00A0E9;
      }
      .collapse-item {
        padding: 28px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.22);
        .collapse-item-img {
          margin-left: 10px;
          height: 24px;
        }
      }
    }
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
      border-width: 0;
    }
    .oneLevel-collapse {
      .van-cell__title {
        font-size: 30px;
        line-height: 42px;
      }
      .van-collapse-item__title {
        padding: 28px 0;
        margin: 0 30px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.22);
      }
      .van-cell__right-icon {
        line-height: 42px;
      }
      .collapse-item {
        font-size: 28px;
        line-height: 42px;
      }
    }
  }
</style>
